import { Text } from './types';

const textTheme: Text = {
	fontSizes: {
		xs: 0,
		s: 1,
		m: 2,
		l: 4,
		xl: 5
	},
	lineHeights: {
		xs: 0,
		s: 1,
		m: 2,
		l: 4,
		xl: 5
	},
	fontWeights: {
		xs: 'regular',
		s: 'regular',
		m: 'regular',
		l: 'regular',
		xl: 'regular'
	}
};

export default textTheme;
